export default __webpack_public_path__ + "static/media/IMG_5080.2567d10e.png";